import { generateCategoricalChart as i } from "./generateCategoricalChart.js";
import { PolarAngleAxis as e } from "../polar/PolarAngleAxis.js";
import { PolarRadiusAxis as a } from "../polar/PolarRadiusAxis.js";
import { formatAxisMap as t } from "../util/PolarUtils.js";
import { Pie as r } from "../polar/Pie.js";
var n = i({
  chartName: "PieChart",
  GraphicalChild: r,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: e
  }, {
    axisType: "radiusAxis",
    AxisComp: a
  }],
  formatAxisMap: t,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
export {
  n as PieChart
};
